module.exports = __webpack_public_path__ + "img/item_CommIllustration_01c.81e1554d.jpeg";